import config from "config/appConfig";

import type { EventModel, PaginationTokenType } from "shared/types";
import type { IStateProps } from "utils/StateOf";
import createStore from "utils/createStore";

const localStorageKey = `${config.GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX}${config.HOOK_STORAGE_KEYS.EVENT_DATA}`;

export interface Values {
	events: EventModel[];
	loading: boolean;
	loadingBefore: boolean;
	loadingAfter: boolean;
	previousToken: PaginationTokenType;
	nextToken: PaginationTokenType;
}

export const initialState: IStateProps<Values> = {
	events: [],
	loading: false,
	loadingBefore: false,
	loadingAfter: false,
	previousToken: null,
	nextToken: null
};

export default createStore<Values>({
	initialState,
	persistant: true,
	persistantName: localStorageKey
});
